import { z } from 'zod';

/** Stable machine-readable error codes the UI may branch on. */
export const errorCodes = [
  'unauthenticated',
  'forbidden',
  'not_found',
  'conflict',
  'validation_failed',
  'precondition_failed',
  'rate_limited',
  'upstream_unavailable',
  'csrf_failed',
  /** The e-mailed code expired or was used up: start the sign-in again. */
  'login_restart_required',
  'internal',
] as const;
export type ErrorCode = (typeof errorCodes)[number];

/** Error body of every failed BFF response. */
export const apiErrorSchema = z.object({
  error: z.object({
    code: z.enum(errorCodes),
    message: z.string(),
    requestId: z.string(),
    fields: z.record(z.string(), z.string()).optional(),
  }),
});
export type ApiError = z.infer<typeof apiErrorSchema>;

export const pageQuerySchema = z.object({
  skip: z.coerce.number().int().min(0).default(0),
  limit: z.coerce.number().int().min(1).max(100).default(25),
});
export type PageQuery = z.infer<typeof pageQuerySchema>;

export const pageSchema = <T extends z.ZodType>(item: T) =>
  z.object({ items: z.array(item), skip: z.number().int(), limit: z.number().int() });
export interface Page<T> {
  items: T[];
  skip: number;
  limit: number;
}

/** Decimal number transported as a string ("3650000.00"), never a float. */
export const decimalSchema = z
  .string()
  .trim()
  .regex(/^-?\d+(\.\d+)?$/, 'Введите число, например 1200.50');

export const organizationParamsSchema = z.object({
  organizationId: z.coerce.number().int().positive(),
});
